document.addEventListener('DOMContentLoaded', () => {

  const priceElements = document.querySelectorAll('.price__current, .price__was');

  priceElements.forEach(priceElement => {
    let priceText = priceElement.innerText.trim();

    if (!priceText) return;

    // Extract the numeric part with optional thousand separator (.) and decimal separator (,)
    let regex = /([\d\.]+),([\d]+)/;
    let match = priceText.match(regex);

    if (match) {
      let base = match[1]; // e.g., "1.129"
      let decimals = match[2]; // e.g., "00"

      // Extract currency symbol
      let currency = '';
      let currencyMatch = priceText.match(/[^\d\s,\.]+/);
      if (currencyMatch) currency = currencyMatch[0];

      // Extract any trailing text (like "HT")
      let trailingText = priceText.replace(regex, '').replace(currency, '').trim();

      priceElement.innerHTML = `${base}<sup>${currency}${decimals}</sup> <small>${trailingText}</small>`;
    }
  });

});